import jwtDecode from 'jwt-decode';
import React from 'react';
import * as errorMsg from "utils/errorMsgConstant";
import api from '../api';


var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, isAuthenticated: true, error: null, numberOfAtemps: 0, user: action.user };
    case 'LOGIN_FAILURE':
      return {
        ...state,
        isAuthenticated: false,
        error: action.error,
        numberOfAtemps: action.numberOfAtemps,
      };
    case 'SIGN_OUT_SUCCESS':
      return { ...state, isAuthenticated: false, error: null };
    case 'SET_CONTAINER_MAX_WIDTH':
      return { ...state, containerMaxWidth: action.payload };
    case 'SET_CURRENT_LANGUAGE':
      // we are working with local storage to prevent getting user data (languag) while refreshing the page
      localStorage.setItem('currentLanguage', action.payload || "FRENCH" );
      return { ...state, currentLanguage: action.payload   || "FRENCH"};
    case 'SET_INACTVE_PERIOD_LIMIT':
      // we are working with local storage to prevent getting user data (languag) while refreshing the page
      localStorage.setItem('inactivePeriodLimit', action.payload);
      return { ...state, inactivePeriodLimit: action.payload };
    case 'USER_SET_ME':
      return {
        ...state,
        me: action.payload
      };

    case 'SELECTED_SHOP_CODE':
      return { ...state, selectedShopCode: action.payload, };
    case 'SECURITY_PASSWORD':
      return { ...state, securityPassword: action.payload, };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem('accessToken'),
    numberOfAtemps: localStorage.numberOfAtemps || 0,
    user: localStorage.getItem('accessToken')
      ? jwtDecode(localStorage.getItem('accessToken')).user
      : null,
    containerMaxWidth: 'lg',
    // default => get browser language
    currentLanguage: localStorage.getItem('currentLanguage') && localStorage.getItem('currentLanguage')!="undefined"
      ? localStorage.getItem('currentLanguage')
      : 'FRENCH',
    inactivePeriodLimit: localStorage.getItem('inactivePeriodLimit') && localStorage.getItem('inactivePeriodLimit') != "undefined" ?
      localStorage.getItem('inactivePeriodLimit') : "",

  });
  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>{children}</UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error('useUserState must be used within a UserProvider');
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error('useUserDispatch must be used within a UserProvider');
  }
  return context;
}

const setConnectedUserData = (dispatch, user) => dispatch({
  type: 'USER_SET_ME',
  payload: user
});

const setSelectedShopCode = (dispatch, selectedShopCode) => dispatch({
  type: 'SELECTED_SHOP_CODE',
  payload: selectedShopCode
});

const setSecurityPassword = (dispatch, securityPassword) => dispatch({
  type: 'SECURITY_PASSWORD',
  payload: securityPassword
});

export {
  UserProvider,
  useUserState,
  useUserDispatch,
  loginUser,
  signOut,
  setContainerMaxWitdh,
  setCurrentLanguage,
  setConnectedUserData,
  setInactivePeriodLimit,
  setSelectedShopCode,
  setSecurityPassword
};

// ###########################################################

function loginUser(
  dispatch,
  login,
  password,
  history,
  setIsLoading,
  setError,
  loadingContextAndErrorContext,
  setTheme, themeDispatch
) {
  setIsLoading(true);

  if (!!login && !!password) {
    api
      .post('/uaa/oauth/token', { login, password, grantType: 'password' })
      .then(r => {

        let token = r.data.access_token
        console.log("login sucesssssss", r.data);
        localStorage.setItem('accessToken', token);
        localStorage.setItem('refresh_token', r.data.refresh_token);
        let user = jwtDecode(localStorage.getItem('accessToken')).user;

        // // get user Theme 
        api.get("/accounts/users/preference?key=USER_THEME", { headers: { Authorization: `Bearer ${token}` } }).then((r) => {
          console.log("themePreference", r.data);
          if (r.data && r.data.value) {
            r.data.value = JSON.parse(r.data.value)
            console.log("USER_THEME sucesss r.data.value", r.data.value);
            // set user theme
            setTheme(themeDispatch, r.data);
          }
        })

        if (user && user.licences.length > 0) {
          // // get client selected shop 
          api.get("/accounts/users/preference?key=SELECTED_SHOP_CODE", { headers: { Authorization: `Bearer ${token}` } }).then((r) => {
            console.log("SELECTED_SHOP_CODE", r.data);
            if (r.data && r.data.value) {
              r.data.value = JSON.parse(r.data.value)
              // verify if saved preference value is included in token licences
              if (user.licences.find(item => item.licenceCode === r.data.value)) {
                localStorage.setItem("selectedShopCode", r.data.value);
                localStorage.setItem("selectedShopPeferenceId", r.data.id);

              } //otherwise  select the first shop 
              else {
                localStorage.setItem("selectedShopCode", user.licences[0].licenceCode);
              }
            }
            // select the first shop if selectedShopCode is null
            else {
              localStorage.setItem("selectedShopCode", user.licences[0].licenceCode);
            }

          }).catch(() => {
            // if api fails 
            localStorage.setItem("selectedShopCode", user.licences[0].licenceCode);
          }).finally(() => {
            // set user token
            dispatch({
              type: 'LOGIN_SUCCESS',
              user: jwtDecode(localStorage.getItem('accessToken')).user,
            });
          })
        }
        // user type is not magassin 
        else {
          // set user token
          dispatch({
            type: 'LOGIN_SUCCESS',
            user: jwtDecode(localStorage.getItem('accessToken')).user,
          });
        }



        localStorage.setItem("cguToValidateTest", user.gcuToValidate);
        let isDistributor = jwtDecode(localStorage.getItem('accessToken')).user.distributor;
        let distributorId = isDistributor
          ? jwtDecode(localStorage.getItem('accessToken')).user.distributorProfile.id
          : '';
        localStorage.setItem(
          'accessRight',
          JSON.stringify({
            articles: false,
            bills: true,
            products: true,
            users: true,
            marks: true,
            country: true,
            domaines: true,
            devise: true,
            password: true,
            cgu: true,
            license: true,
            tiers: user.client ? false : true,
            tarif: user.admin ? true : false,
            // "user": user.admin ? true : false,
            user: true,
          }),
        );

        const GetuserType = () => {
          if (user.distributor && !user.admin) {
            return ['DISTRIBUTOR'];
          }
          if (!user.distributor && user.admin) {
            return ['ADMINISTRATOR'];
          }

          if (user.distributor && user.admin) {
            return ['ADMINISTRATOR', 'DISTRIBUTOR'];
          }
          // ********
        };

        // FSP => filter sort pagination
        // Setting intial pagination in local storage for next and previous feature inital case
        localStorage.setItem(
          'markListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'deviseListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'domainListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'paysListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'tiersListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            distributorId: isDistributor ? distributorId : '',
            countryId: '',
            clientType: false,
            distributorType: false,
            facturationType: false,
            supportType: false,
            regroupingType: false,
          }),
        );
        localStorage.setItem(
          'tarifListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            deviseId: '',
          }),
        );
        localStorage.setItem(
          'licenceListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            // ????
            distributorId: distributorId,
            //  ou bien  distributorId:"", car intialisé fi context haka
            countryId: '',
            supportUnitsIds: '',
            markId: user.distributorProfile && user.distributorProfile.distributorMarkId ?
              user.distributorProfile.distributorMarkId : "",
            domainId: '',
            facturationId: '',
            regroupingId: '',
            magasinId: '',
            licenseTypes: '',
            adminId: '', // it's not a boolean value
            from: null,
            to: null,
          }),
        );
        localStorage.setItem(
          'userListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            userTypes: '',
            distributorId: isDistributor ? distributorId : '',
            licenceId: '',
          }),
        );
        // 99
        localStorage.setItem(
          'roleListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            types: GetuserType(),
            distributorId: '',
          }),
        );
        localStorage.setItem(
          'notificationListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            status: ['WAITING'],
          }),
        );
        localStorage.setItem(
          'licenceRequestListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            activityDomainId: [""],
            countryId: '',
            language: '',
            distributorId: '',
            beginSoumissionDate: null,
            endSoumissionDate: null,
            beginDecisionDate: null,
            endDecisionDate: null,
            status: ['WAITING'],
          }),
        );
        localStorage.setItem(
          'ticketListFSP',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            distributorId: distributorId,
            licenceDistributorId: '',

            includeNotAffectedTickets: true,
            licenceId: '',
            // objet fi user story
            types: [""],
            status: [""],
            severities: [""],
            creationDateBegin: null,
            creationDateEnd: null,
            closureDateBegin: null,
            closureDateEnd: null,
            assigneToUserId: '',
          }),
        );

        // ************client entity***********************
        // FSPM => filter sort pagination magasin(entity relative to client (magasin))
        localStorage.setItem(
          'postalCodeListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            countryId: '',
          }),
        );
        localStorage.setItem(
          'articleFamilyListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'articleMarkListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'customerProvenanceListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'stockOutTypeListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );
        localStorage.setItem(
          'identityListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            isCompany: false,
          }),
        );

        localStorage.setItem(
          'bankAccountListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'clientCountryListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'clientCurrencyListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'articleClassification1ListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'articleClassification2ListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'articleClassification2ListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'articleSubFamilyListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            articleFamiliesIds: [""],
          }),
        );

        localStorage.setItem(
          'articleUniverListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'articleVariantListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'articleCharacteristicListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'labelTextListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'dataCollectSectionListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'paymentDeadlineListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: "",
          }),
        );

        localStorage.setItem(
          'supplierFamilyListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'deliveryZoneListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
          }),
        );

        localStorage.setItem(
          'paymentMethodListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'customerFamilyListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'gdrpConsentListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'documentCommentListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'vatProfileListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'taxeListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'globalBudgetListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'supplierListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
            supplierFamilyId: ""
          }),
        );

        localStorage.setItem(
          'accountingProfileListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'loyaltyProfileListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem(
          'budgetLineListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        localStorage.setItem("dossierListFSP", JSON.stringify({
          page: 1, pageSize: 10,
          freeField: "",
          order: null,
          orderBy: null,
          creationDone: "",
          includeNotAffectedDossiers: "",
          false: false,
          null: true,
        }));

        localStorage.setItem(
          'userShopListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            userTypes: '',
            distributorId: isDistributor ? distributorId : '',
            licenceId: '',
          }),
        );

        localStorage.setItem(
          'customerListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            customerFamilyId: "",
            isCompany: ""
          }),
        );

        localStorage.setItem(
          'advertisingOperationListFSPM',
          JSON.stringify({
            page: 1,
            pageSize: 10,
            freeField: '',
            order: null,
            orderBy: null,
            actif: true,
            inactif: false,
            type: '',
          }),
        );

        // set local language while login
        dispatch({
          type: 'SET_CURRENT_LANGUAGE',
          payload: jwtDecode(localStorage.getItem('accessToken')).user.language,
        });

        // set local inactivePeriodLimit while login
        dispatch({
          type: 'SET_INACTVE_PERIOD_LIMIT',
          payload: jwtDecode(localStorage.getItem('accessToken')).user.inactivePeriodLimit,
        });

        localStorage.removeItem('numberOfAtemps');
        return r;
      })
      .catch(e => {
        setIsLoading(false);
        console.log('catch eerrror isss', e);
        if (e && e.status === 401) {
          loadingContextAndErrorContext.snackbar.setOpen(true);
          loadingContextAndErrorContext.snackbar.setMsg(
            "Le nom d'utilisateur ou le mot de passe est incorrect!",
          );
          loadingContextAndErrorContext.snackbar.setSeverity('error');
        }
        else {
          if (e && e.data && e.data.code) {
            loadingContextAndErrorContext.snackbar.setOpen(true);
            loadingContextAndErrorContext.snackbar.setMsg(errorMsg[e.data.code]);
            loadingContextAndErrorContext.snackbar.setSeverity("error");
          }
          else {
            loadingContextAndErrorContext.snackbar.setOpen(true);
            loadingContextAndErrorContext.snackbar.setMsg('Opération échouée');
            loadingContextAndErrorContext.snackbar.setSeverity('error');
          }
        }

        if (!localStorage.getItem('numberOfAtemps')) {
          localStorage.setItem('numberOfAtemps', 1);
        } else {
          var numberOfAtemps = localStorage.getItem('numberOfAtemps');
          numberOfAtemps++;
          localStorage.setItem('numberOfAtemps', numberOfAtemps);
        }
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        dispatch({
          type: 'LOGIN_FAILURE',
          error:
            e && e.response
              ? e.response.data.message
              : "Le nom d'utilisateur ou le mot de passe est incorrect! Veuillez réessayer.",
          numberOfAtemps,
        });
        return e;
      });
  } else {
    dispatch({
      type: 'LOGIN_FAILURE',
      error: "Le nom d'utilisateur ou le mot de passe est incorrect! Veuillez réessayer.",
    });
    setIsLoading(false);
  }
}
function signOut(dispatch, history) {
  localStorage.clear();
  window.location.reload(false)
  dispatch({ type: 'SIGN_OUT_SUCCESS' });
  history.push('/login');
}

function setContainerMaxWitdh(dispatch, maxWidth) {
  console.log('setContainerMaxWitdh', maxWidth);
  dispatch({
    type: 'SET_CONTAINER_MAX_WIDTH',
    payload: maxWidth,
  });
}

function setCurrentLanguage(dispatch, langauge) {
  dispatch({
    type: 'SET_CURRENT_LANGUAGE',
    payload: langauge,
  });
}

function setInactivePeriodLimit(dispatch, period) {
  dispatch({
    type: 'SET_INACTVE_PERIOD_LIMIT',
    payload: period,
  });
}

